export { default as CoverStoryHero } from './CoverStoryHero';